export default __webpack_public_path__ + "static/media/hostfully_step15.288926a5.png";